<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page mt-5" v-else-if="loaded" >
        
        <div class="col-12 col-md-10 offset-md-1" >            
            <div class="row no-gutters" >
                <h2 class="h2" v-if="pageType == 'add' " > Create automation </h2>
                <h2 class="h2" v-else-if="pageType == 'edit' " > Edit automation </h2>
            </div>      
            <div class="row no-gutters mt-3" >            

                <b-form  @submit.prevent="submit" class="atlass-form col-12 mt-md-4" >
                    
                    <!--
                    <div class="row d-none">
                        
                        <div class="col-12 form-group" >
                            <label for="NameInput" > NAME: </label>
                            <b-form-input id="NameInput" @keyup="nameToTag"
                            type="text"
                            v-model="data.name"
                            required

                            placeholder="Name">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 form-group form-group-small" >
                            <label for="TagInput" > TAG: </label>
                                <b-input-group class="mb-2 p-0">
                                    <b-input-group-prepend is-text> 
                                        <b-form-select v-model="data.tagType" class="small-select" :options="optionsTagType"></b-form-select>
                                    </b-input-group-prepend>
                                    <b-form-input id="TagInput" 
                                    type="text"
                                    v-model="data.tag"
                                    required
                                    disabled
                                    placeholder="name"></b-form-input>
                                </b-input-group>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <label for="word" > ADD WORD: </label>
                                <b-form-input id="word" @change="addWord"
                                type="text"
                                v-model="data.word"
                                placeholder="ex: thank-you">
                                </b-form-input>
                            
                            <label for="parameter" class="d-block mt-3 mb-2" >WORDS TO WATCH:</label>
                            <div class="" > 
                                <span v-for="(word, index) in data.wordsToMatch" class="d-inline-block box-span box-span-removeable" > {{word}} <font-awesome-icon icon="times" @click="removeFromArray(word)" /> </span>
                            </div>
                            
                        </div>
                        
                        <div class="col-12 form-group" >
                            <b-button type="submit" variant="primary" class="btn-sm-w" >Save</b-button>
                            <b-button  class="btn btn-danger btn-sm-w" @click="PreventDelete()" v-if="pageType == 'edit'" > Delete </b-button >
                        </div>
                        
                    </div>
                    -->
                    
                    <div class="row w-100">
                            
                        <b-alert show variant="secondary" class="w-100 mb-0" >
                            <strong> If user interacts with a link containing either one of these words: </strong>
                            <br>
                            <i> Eg.: https://theatlass.com/site/demo-thank-you.html </i>
                            
                            <br>
                            <div class="mt-3 mb-3" style="min-height: 33px;" > 
                                <span v-if="data.wordsToMatch.length == 0" class="alert alert-primary d-block p-0 pl-5 pr-5 text-center mr-5 ml-5" style="margin-top: 5px; margin-bottom: 5px;" > No words added yet. Add them below. </span>
                                
                                <span v-for="(word, index) in data.wordsToMatch" class="d-inline-block box-span box-span-removeable bg-color-white" style="background: #fff!important;"   > {{word}} <font-awesome-icon icon="times" @click="removeFromArray(word)" /> </span>
                            </div>

                            <label for="word" > ADD WORD: </label>
                            <b-form-input id="word" @change="addWord"
                                type="text"
                                v-model="data.word"
                                style="background: #fff!important;"  
                                placeholder="ex: thank-you">
                            </b-form-input>

                        </b-alert>      
                        
                        <div class="vertical-line" style="height: 100px; width: 1px; border-left:2px dashed #d6d8db; margin-left: 50%;" ></div>
                        
                        <b-alert show variant="secondary" class="w-100" >
                            <strong> Apply this tag: </strong>

                            <div class="col-12 form-group" >
                                <label for="NameInput" > NAME: </label>
                                <b-form-input id="NameInput" @keyup="nameToTag"
                                type="text"
                                v-model="data.name"
                                required
                                style="background: #fff!important;"     
                                placeholder="Tag Name">
                                </b-form-input>
                            </div>

                            <div class="col-12 form-group form-group-small"  >
                                <label for="TagInput" > TAG: </label>
                                    <b-input-group class="mb-2 p-0">
                                        <b-input-group-prepend is-text> 
                                            <b-form-select v-model="data.tagType" class="small-select" :options="optionsTagType"></b-form-select>
                                        </b-input-group-prepend>
                                        <b-form-input id="TagInput" 
                                        type="text"
                                        v-model="data.tag"
                                        style="background: #fff!important;"  
                                        required
                                        disabled
                                        placeholder="tag"></b-form-input>
                                    </b-input-group>
                            </div>

                        </b-alert>                            

                        <div class="col-12 col-md-6 offset-md-3 mt-md-5" >
                            <b-button type="submit" variant="primary" class="btn-sm-w" >Save</b-button>
                            <b-button  class="btn btn-danger btn-sm-w" @click="PreventDelete()" v-if="pageType == 'edit'" > Delete </b-button >
                        </div>
                        
                    </div>
                    
                </b-form>
                
                
            </div>
        </div>

    </div>

</template>

<script>
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'watcher',
    props: {
        ID: { 
            type: [String],
        }
        
    },
    data: function(){
        return {
            data: {
                name: '',
                tag: '',
                word: '',
                tagType: 0,
                wordsToMatch: []
            },
            errors: [],
            loaded: false,
            rows: [],
            pageType: 'add',
            requestStatus: 0,
            timeout: 100,
            optionsTagType: [
                { value: 0, text: '!' },
                { value: 1, text: '@' },
                { value: 2, text: '$' },
            ]
        }
    },
    ready: function (){
        
    },
    beforeCreate: function (){
        
    },
    mounted(){
        if( this.ID ){
            this.pageType = 'edit'
            this.getdata();
        }else{
            this.loaded = true
        }
    },
    created: function () {
        
    },
    beforeDestroy() {
    },
    methods: {
        getdata: function(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/milestones').doc(this.ID)

            return ref.get()
            .then((snapshot) => {
                //console.log(snapshot.data())
                this.data = snapshot.data()
                
                this.loaded = true
            })
            
        },
        nameToTag: function(){
            let name = this.data.name;
            if( this.pageType == 'add' ){
                name = name.toLowerCase()
                let tag = name.replace(/\s/g, "-");
                this.data.tag = tag;
            }
                
        },
        addWord: function(){
            let word = this.data.word
            this.data.wordsToMatch.push( word )
            this.data.word = ''
        },
        removeFromArray: function(word){
            this.data.wordsToMatch = this.data.wordsToMatch.filter(item => item !== word)
        },
        submit: function(){
            
            this.loaded = false
            
            let resp = this.save()
            resp.then(function(){
                
                    console.log("Success")
                     this.$toast.success({
                        title:'Success',
                        message: 'Automation saved'
                    })

                    setTimeout(function(){ 
                        this.loaded = true
                        this.$parent.$parent.get_data();
                        this.$parent.fModalClose();
                    }.bind(this), this.imeout );
                
                    
                
                }.bind(this))
                .catch(function(error){
                
                    //console.error("Error updating document: ", error);
                    this.$toast.error({
                        title:'Error',
                        message: "Something went wrong: "+error
                    })
                
                    this.loaded = true
                
                }.bind(this))
            
            
            
        },
        save: function () {
            //const { firstname, lastname, website, organization, address, city, country } = this.getprofile
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let document = {
                    "APPKEY": orgID,
                    "name" : this.data.name,
                    "tagType" : this.data.tagType,
                    "tag" : this.data.tag,
                    "wordsToMatch" : this.data.wordsToMatch,
                }
            
            if( this.pageType == 'add' ){

                document.datetime = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/milestones')
                
                return ref.add( document )
                
            }else{
                
                document.last_update = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/milestones').doc( this.ID )
                
                return ref.set( document, { merge: true } )
                
            }
            
        },
        
        PreventDelete( ){
            
            this.$parent.$parent.PreventDelete( this.ID );
            
        },        

    },
    computed: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/automation.vue